import { getAction } from "@/api/manage";
export default {
  data: function data() {
    return {
      cmsDataSource: [],
      currentTab: '11'
    };
  },
  created: function created() {
    console.log(this.currentTab);
    if (this.$route.query.type) {
      this.currentTab = this.$route.query.type;
    } else {}
    console.log(this.currentTab);
    this.getCmsList(this.currentTab);
  },
  watch: {
    $route: function $route(v) {
      if (this.$route.query.type) {
        this.currentTab = this.$route.query.type;
      } else {
        this.currentTab = "11";
      }
      this.getCmsList(this.$route.query.type);
    }
  },
  methods: {
    getCmsList: function getCmsList(type) {
      var _this = this;
      this.cmsType = type;
      this.cmsDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: type,
        pageSize: 10
      }).then(function (res) {
        if (res.success) {
          _this.cmsDataSource = res.result.records;
        }
      });
    },
    toCmsDetail: function toCmsDetail(item) {
      var route = this.$router.resolve({
        path: "/cms/detail",
        query: {
          id: item.id
        }
      });
      window.open(route.href, '_blank');
    }
  }
};